import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function CertificationNotice() {
  return <div className="w-full pt-12 md:pt-16" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-937">
      <div className="max-w-4xl mx-auto px-4 md:px-8" data-id="element-938">
        <div className="flex items-start gap-4 p-5 rounded-xl mb-12 border-2" style={{
        backgroundColor: '#f0f7f3',
        borderColor: '#1e3d2f'
      }} data-id="element-939">
          <ShieldCheckIcon size={24} className="flex-shrink-0 mt-0.5" style={{
          color: '#1e3d2f'
        }} data-id="element-940" />
          <p className="text-base font-semibold" style={{
          color: '#1e3d2f',
          fontFamily: 'Inter, sans-serif'
        }} data-id="element-941">
            This course satisfies Michigan's training requirements to obtain a
            Concealed Pistol License.
          </p>
        </div>
      </div>
    </div>;
}